<template>
<div>
    <div>

    </div>

  <v-app id="inspire">
    <v-content>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="4">
            <v-card class="elevation-12">
              <v-toolbar color="primary" dark flat>
                <v-icon>info</v-icon>
                <v-toolbar-title>Nova password detectada</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>

              <v-card-text>
                   <p>O sistema detectou que está a usar uma password não criada por sí.</p>
                  <p>Por favor, alterar a sua password antes de prosseguir clicando <v-btn text to="/mudar-senha-login">aqui</v-btn></p>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</div>
</template>

<script>
import axios from '../../plugins/axios'
import { v4 as uuidv4 } from 'uuid'
const ls = require('local-storage')
export default {
  props: {
    source: String
  },
  data: () => ({
    formValid: true,
    conectionStatus: '',
    progresso: false,
    nomeUsuario: ls.get('nomeUsuario'),
    counter_: 0,
    usernameRule: [
      // this.value.replace(/[^\d]/, ''),

      v => !!v || 'campo obrigatório.',
      v => {
        const pattern = /([^A-Za-z0-9])$/
        return !pattern.test(v) || 'Inválido.'
      }
    ],
    drawer: null,
    user: {
      username: '',
      password: ''
    },
    long: '',
    lat: ''
  }),

  computed: {
    loggedUser () {
      const user = this.$store.getters.loggedUser
      return user // this.$session.get("role")// this.$session.getAll()// this.$session.flash.get("role")
    },
    falal () {
      return ls.get('fatal')
    }

  },

  created () {
    this.CheckConection()
    console.log(this.conectionStatus)
  },

  methods: {

    CheckConection () {
      if (!navigator.onLine) { this.conectionStatus = 'Verifique a sua conexão de internet' }
    },

    async login () {
      this.progresso = true

      const pattern = /([^A-Za-z0-9])$/

      if (!this.user.username.includes("'") && !this.user.username.includes('"') && !this.user.username.includes('-')) {
        const userCredencial =
        '{"username":"' +
        this.user.username +
        '", "password":"' +
        this.user.password +
        '"}'

        try {
          const textMessage = await axios
            .post('/login/' + userCredencial)
            .then(res => res.data)
          this.CarregActividades()
          this.progresso = false

          // this.$session.start()

          // this.$store.state.loggedUser.push({"token":textMessage.token,"idPessoa":textMessage.idPessoa, "role":textMessage.role,"i_id":textMessage.i_id})
          // console.log("ver remsg:"+ Object.values(textMessage))

          const loggedUser = {
            token: textMessage.token,
            idPessoa: textMessage.idPessoa,
            role: textMessage.role,
            username: textMessage.username,
            instituicao: textMessage.instituicao,
            sigla: textMessage.sigla,
            instituicaodescricao: textMessage.instituicaodescricao,
            anolectivo: textMessage.anolectivo,
            idanolectivo: textMessage.idanolectivo,
            nomeUsuario: textMessage.nomeUsuario,
            uuid: uuidv4(),
            actividades: this.$store.state.actividades

          // Guarda o uniqueuserid do usuário logado
          }

          this.$store.dispatch('loggedUser', loggedUser) // mando para a store.js
          this.$store.dispatch('textMessage', { 'msg': 'Parabens, você logou  com sucesso !', 'classMessage': 'msgSucess', 'timeout': 3000 })

          // this.countDown();
          this.GetUserLocation(textMessage)
          this.$router.push('welcome')
        } catch (error) {
          console.log('eroooo: ' + error)
          this.$store.dispatch('textMessage', { 'msg': 'Usuärio ou senha incorrecta !', 'classMessage': 'msgError', 'timeout': 3000 })
        } finally {
          this.progresso = false
        }
      } else {
        this.$store.dispatch('textMessage', { 'msg': 'Inválido !', 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    async CarregActividades () {
      try {
        this.$store.state.actividades = await axios
          .get('/listAberturaFechoInstituicao')
          .then(res => res.data)
        // console.log( this.$store.state.actividades);
      } catch (error) {

      }
    },

    async  GetUserLocation (textMessage) {
      let latitude = ''
      let longitude = ''
      /** /   try {
        this.$getLocation()
          .then(coordinates => {
            let location = Object.values(coordinates)

            let valores = location.toString().split(',')
            latitude = valores[0]
            longitude = valores[1]

          })
      } catch (error) {
        console.log('this.$getLocation() error: ' + error)
      }
*/
      this.LoginlogsInsert(longitude, latitude)// here I am calling  the methodo to insert in database
    },
    async LoginlogsInsert (longitude, latitude) {
      let dtt = await this.ObterDataTimeRemote()
      const params =
      {
        loginUpdate: 0,
        username: ls.get('idPessoa'),
        nome: ls.get('nomeUsuario'),
        datain: dtt,
        dataout: '',
        autor: ls.get('nomeUsuario'),
        loginpkCode: ls.get('uuid'),
        instituicao: ls.get('instituicaodescricao'),
        role: ls.get('role'),
        latitude: 'latitude',
        longitude: 'longitude'

      }

      // consumindo a API
      try {
        let msg = await axios
          .post('/InsertOrUpdateLoginLogs', params)
          .then(res => res.data)
      } catch (error) {

      }
    },
    ObterDataTimeRemote () {
      var today = new Date()
      var day = today.getDate() + ''
      var month = (today.getMonth() + 1) + ''
      var year = today.getFullYear() + ''
      var hour = today.getHours() + ''
      var minutes = today.getMinutes() + ''
      var seconds = today.getSeconds() + ''

      day = checkZero(day)
      month = checkZero(month)
      year = checkZero(year)
      hour = checkZero(hour)
      minutes = checkZero(minutes)
      seconds = checkZero(seconds)

      return (year + '-' + month + '-' + day + ' ' + hour + ':' + minutes + ':' + seconds)

      function checkZero (data) {
        if (data.length == 1) {
          data = '0' + data
        }
        return data
      }
    }

  }

}
</script>
<style scoped>

</style>
